export default "__VITE_ASSET__DgGmpKPf__"